<!-- @Version: 1.0.2 --> 
<div class="button button-toggle-container" data-testid="fileuploadContainer" >
   <mat-button-toggle-group  class="set-color-unchecked" [formControl]="fcFileuploadButton" data-testid="toggle-group">
      <mat-button-toggle [attr.color]="fcFileuploadButton.dirty && fileUploaded && uploadFileData.length > 0 ?  colorSuccess : colorDefault" data-testid="click-button-fileupload" value="true">
         @if (iconDefault && iconSuccess) {
            <mat-icon data-testid="fileuploadIcon">{{fcFileuploadButton.dirty && fileUploaded && uploadFileData.length > 0 ? iconSuccess : iconDefault}}</mat-icon>
         }{{fieldItem.attribute_6}}
      </mat-button-toggle>
   </mat-button-toggle-group>

   @if (fieldItem.required && fcFileuploadButton.pristine && !fileUploaded) {
      <mat-hint data-testid="required-hint">{{TRANSLATE_PATH.REQUIRED | translateDesign}}</mat-hint>
   }
   @else if (fcFileuploadButton.dirty && fileUploaded && uploadFileData.length > 0) {
      <mat-hint data-testid="done-message">{{TRANSLATE_PATH.FILEUPLOAD_DONE | translateDesign}}</mat-hint>
   }
   @else {
      <mat-hint data-testid="hint-placeholder" class="visibility">&nbsp;</mat-hint>
   }
</div>